import { render, staticRenderFns } from "./KnDocItem.vue?vue&type=template&id=4e03fe2a&"
import script from "./KnDocItem.vue?vue&type=script&lang=js&"
export * from "./KnDocItem.vue?vue&type=script&lang=js&"
import style0 from "./KnDocItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports